// extracted by mini-css-extract-plugin
module.exports = {"monitor-area":"monitor-area___1pf9h"};